import { Role } from "../../types/role";

const HASun: Role = {
  primary: [
    "Ballannahme",
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Nervenstaerke",
    "OhneBall",
    "Teamwork",
  ],
  secondary: [
    "Abschluss",
    "Aggressivitaet",
    "Antizipation",
    "Flair",
    "Uebersicht",
    "Balance",
    "Kraft",
  ],
  physis: "angriff",
};

const HASan: Role = {
  primary: [
    "Ballannahme",
    "Passen",
    "Technik",
    "Entscheidungen",
    "Nervenstaerke",
    "OhneBall",
    "Teamwork",
  ],
  secondary: [
    "Abschluss",
    "Dribbling",
    "Antizipation",
    "Flair",
    "Uebersicht",
    "Balance",
    "Kraft",
  ],
  physis: "angriff",
};

export const HAS = {
  HASun,
  HASan,
};
